import { render, staticRenderFns } from "./PzNaat.vue?vue&type=template&id=11797414"
import script from "./PzNaat.vue?vue&type=script&lang=js"
export * from "./PzNaat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dayanamartinez/Developer/laas_simulator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11797414')) {
      api.createRecord('11797414', component.options)
    } else {
      api.reload('11797414', component.options)
    }
    module.hot.accept("./PzNaat.vue?vue&type=template&id=11797414", function () {
      api.rerender('11797414', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/commons/forms/DigitalSings/Naat/PzNaat.vue"
export default component.exports